/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * AnnouncemenrBar slider on mobile
 */
function initAnnouncementSlider() {
  var announcementSliderElem = document.querySelector('[data-announcement-slider]');
  var announcementSlides = document.querySelectorAll('[data-announcement-slide]');

  // Check if announcementbar is enabled
  if (!announcementSliderElem) {
    return;
  }

  // Return if there are only 1 slide
  if (announcementSlides.length <= 1) {
    return;
  }

  // Init slider
  var announcementSlider = new Flickity(announcementSliderElem, {
    // options
    cellAlign: 'center',
    contain: true,
    prevNextButtons: false,
    pageDots: false,
    watchCSS: true,
    autoPlay: 5000
  });

}
initAnnouncementSlider();

/**
* Cart terms
*/
function modalHandler(event, resp) {
  event.preventDefault();

  var terms = document.querySelector('[data-cart-terms]');
  var termsModal = document.querySelector('[data-terms-modal]');

  if (resp) {
    terms.checked = true;
  }

  termsModal.classList.remove('is--open');
}

function termsHandler(event) {
  var terms = document.querySelector('[data-cart-terms]');
  var termsModal = document.querySelector('[data-terms-modal]');

  if (!terms.checked) {
    event.preventDefault();
    termsModal.classList.add('is--open');
  }
  else{
    document.dispatchEvent( new CustomEvent('goToCheckout',{
      bubbles: true
  }))
  }

}

/**
 * Clerk
 */
var productClerkData = document.getElementById("product-clerk-data")
var jsonClerkData = JSON.parse(productClerkData.innerHTML)

const sizes = (media, aspect) => {
  const availableSizes = [];
  const widths = [
    30, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330, 360,
    390, 420, 450, 480, 510, 540, 570, 600, 630, 660, 690, 720,
    750, 780, 810, 840, 870, 900, 930, 960, 1020, 1080, 1140, 1200,
    1260, 1320, 1380, 1440, 1500, 1560, 1620, 1680, 1740, 1800, 1860, 1920,
    2040, 2160, 2280, 2400, 2520, 2640, 2760, 2880,
  ];

  for (let i = 0; i < widths.length; i += 1) {
    const width = widths[i];
    const height = width / aspect;

    if (media.width <= width) {
      break;
    }

    if (media.height <= height) {
      break;
    }

    availableSizes.push(width);
  }

  return availableSizes;
};

const url = (imageData) => {
  const output = new URL((imageData.src ?? imageData.url),document.location.origin);

  output.searchParams.append('width', '{width}');
  output.searchParams.append('height', '{height}');
  output.searchParams.append('crop', 'center');

  return decodeURI(output.toString());
};

const image = (imageData, aspect = imageData.width / imageData.height) => `
  <img
    src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
    data-src="${url(imageData)}"
    data-aspectratio="${aspect}"
    data-sizes="auto"
    data-widths="[${sizes(imageData, aspect).join(',')}]"
    alt="${imageData.alt ?? ''}"
    class="ProductItem__Image Image--fadeIn lazyautosizes Image--lazyLoad"
  >
`;

function clerkItem(product) {
  const title = function () {
    var metafieldTitle = product.meta_product_title?.split('_')
    var result = ''
    if (metafieldTitle && metafieldTitle.length > 0) {
      result = `
      <p>${metafieldTitle[0]}</p>
      <p>${metafieldTitle[metafieldTitle.length - 1]}</p>
      `
    } else {
      result = product.title
    }
    return result
  }
  const windforce = function () {
    var windforceNumber = product.meta_windforce
    var windforceResult = ''
    if (windforceNumber === null) {
      windforceResult = `
      <div class="ProductCard__Label Label--round vis-hidden">
        <p>${product.meta_windforce}</p>
      </div>
      `
    } else {
      windforceResult = `
      <div class="ProductCard__Label Label--round">
        <p>${product.meta_windforce}</p>
      </div>
      `
    }
    return windforceResult
  }
  var price = product.price < product.compare_at_price ? `<p class="ProductCard__CompareAtPrice">${Shopify.formatMoney(product.compare_at_price, theme.moneyFormat)}</p>` : ''
  return `
    <div class="Carousel__Cell is-selected" data-clerk-product-id="${product.id}"> 
      <div class="ProductCard">
      <a class="ProductCard__Link" href="${product.url}"></a>
      <div class="ProductCard__Overlay"></div>

      <div class="ProductCard__Labels ProductCard__Labels--info"></div>

      <div class="ProductCard__ImageWrapper">
        <a href="${product.url}" class="ProductItem__ImageWrapper "><div class="AspectRatio AspectRatio--natural" style="max-width: 3210px;  --aspect-ratio: 1.0">${image(product.images[0])}
          <span class="Image__Loader"></span>

          <noscript>
            <img class="ProductItem__Image ProductItem__Image--alternate" src="${product.images[0].src}" alt="">
              <img class="ProductItem__Image" src="${product.images[0].src}" alt="">
              </noscript>
            </div>
          </a>
        </div>

          <article class="ProductCard__Meta">
            <div class="ProductCard__SmallDescription">
              ${product.meta_product_item_desc}
            </div>
            <div class="ProductCard__Labels ProductCard__Labels--styrke">
              ${windforce()}
            </div>
            <h3 class="ProductCard__Title">
              ${title()}
            </h3>
            <div class="ProductCard__Prices">
              ${price}
              <p class="ProductCard__Price">${Shopify.formatMoney(product.price, theme.moneyFormat)}</p>
            </div>

            <div class="ProductCard__Cta">
              <a href="${product.url}" class="Button Button--primary">${languages.viewProduct}</a>
            </div>
          </article>
      </div>
    </div>
  `
}

const clerkSliders = document.querySelectorAll('.clerk-slider')
clerkSliders.forEach(slider => {
  const endpoint = slider.dataset.api;
  const config = JSON.parse(slider.dataset.config);
  const filterScript = slider.querySelector('[data-filter]');

  if (filterScript) {
    config.filter = filterScript.textContent;
  }

  config.attributes = ['handle']; // produkt data

  var flickityConfig = {
    prevNextButtons: false,
    pageDots: true,
    wrapAround: false,
    contain: true,
    cellAlign: "center",
    watchCSS: true,
    dragThreshold: 8,
    groupCells: true,
    arrowShape: { "x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25 }
  }

  var flickityConfigProductPage = {
    prevNextButtons: true,
    pageDots: false,
    wrapAround: false,
    contain: true,
    cellAlign: "center",
    watchCSS: true,
    dragThreshold: 8,
    groupCells: true,
    arrowShape: { "x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25 }
  }


  const sliderWrapper = slider.querySelector('[data-slides]');
  window.Clerk('call', endpoint, config,
    (response) => {
      response.product_data.forEach((product) => {

        if(!product) return 
        var data = jsonClerkData.find(i => i.handle === product.handle)
        if (data) sliderWrapper.insertAdjacentHTML('beforeend', `${clerkItem(data)}`);

      });

      window.Clerk('click', '*[data-clerk-product-id]');
      var flick = new Flickity(sliderWrapper, location.pathname.includes("/products/") ? flickityConfigProductPage : flickityConfig)

      if (!location.pathname.includes("/products/")) {
        var nextArrow = slider.querySelector('[data-next-arrow]')
        var prevArrow = slider.querySelector('[data-prev-arrow]')
        if (prevArrow) prevArrow.addEventListener('click', _prevSlide.bind(this));
        if (nextArrow) nextArrow.addEventListener('click', _nextSlide.bind(this));
        function _prevSlide(event, target) {
          flick.previous();
          _updateArrows();
        }

        function _nextSlide(event, target) {
          flick.next();
          _updateArrows();
        }

        function _updateArrows(event, target) {
          var totalSlides = flick.slides.length;
          var current = flick.selectedIndex;

          if (prevArrow) {
            if (current == 0) {
              prevArrow.setAttribute("disabled", "disabled")
            } else {
              prevArrow.removeAttribute("disabled")
            }
          }
          if (nextArrow) {
            if (current == totalSlides - 1) {
              nextArrow.setAttribute("disabled", "disabled")
            } else {
              nextArrow.removeAttribute("disabled")
            }
          }
        }
      }
    },
    (response) => {
      // eslint-disable-next-line no-console
      console.error(response);
    });
});
